'use strict';

(() => {
  const barra = document.querySelector('[data-barra-fija]');
  if (!barra) return;

  const precio = barra.querySelector('[data-barra-precio]');
  const pintar = (estado) => {
    if (estado && estado.etiqueta) precio.textContent = estado.etiqueta;
  };
  document.addEventListener('zoremina:precio', (evento) => pintar(evento.detail));

  let cajaPasada = false;
  let cercaDelPie = false;
  const actualizar = () => {
    const visible = cajaPasada && !cercaDelPie;
    barra.classList.toggle('es-visible', visible);
    barra.inert = !visible;
    barra.setAttribute('aria-hidden', String(!visible));
  };

  const iniciar = () => {
    pintar(window.zoremina);
    const caja = document.getElementById('comprar');
    const pie = document.querySelector('footer');
    if (caja) {
      new IntersectionObserver(([entrada]) => {
        cajaPasada = !entrada.isIntersecting && entrada.boundingClientRect.bottom < 0;
        actualizar();
      }).observe(caja);
    }
    if (pie) {
      new IntersectionObserver(
        ([entrada]) => {
          cercaDelPie = entrada.isIntersecting;
          actualizar();
        },
        { rootMargin: '0px 0px 160px 0px' },
      ).observe(pie);
    }
  };

  iniciar();
})();
